<nav id="header-nav" class="navbar bg-light mh-fixed-top">
  <div class="container-xl">
    <!-- Brand Logo -->
    @if (!headerConfig().hideLogo && !isAuthenticated()) {
      <a
        class="navbar-brand order-0"
        routerLink="/"
        [ngClass]="{ 'mx-auto': headerConfig().hideNavMenu && headerConfig().hideNavActions }"
      >
        <img
          [src]="mainLogoIcon?.svg || mainLogoIcon?.jpg || mainLogoIcon?.png"
          alt="Agent Portal logo"
          [width]="240"
          [height]="64"
          priority
        />
      </a>
    }

    @if (isAuthenticated()) {
      <img [src]="myHomeFavicon?.svg" alt="MyHome Favicon" />
      <div class="vr my-3"></div>
      <ng-container [ngTemplateOutlet]="agentPortalLogoTemplate" />
    }

    <!-- Menu Items -->
    @if (!headerConfig().hideNavMenu && isAuthenticated()) {
      <ul jest-id="header-menu" class="order-0 navbar-nav flex-fill d-none d-lg-flex">
        @for (item of headerMenu(); track $index) {
          @if (showNavItem(item)) {
            <ng-container
              [ngTemplateOutlet]="initialItemTemplate"
              [ngTemplateOutletContext]="{ item: item, isSubmenu: false }"
            />
          }
        }
      </ul>
    } @else if (isAuthenticated()) {
      <!-- Spacer to push items to the right when menu is hidden -->
      <div class="flex-fill"></div>
    }

    <!-- Other action menu items -->
    @if (!headerConfig().hideNavActions) {
      @if (!actionMenu().length && isAuthenticated() && isOfficeSite()) {
        <a
          class="btn btn-primary order-lg-1 order-last col-12 col-lg-auto mt-3 mb-2 my-lg-0 ms-lg-3"
          routerLink="properties/add"
        >
          <svg-icon [src]="addIcon?.svg" [applyClass]="true" /> Add Property
        </a>
      } @else {
        <div class="flex-fill"></div>
      }

      @if (isAuthenticated()) {
        <ul class="navbar-nav action-navs order-2">
          @if (actionMenu().length > 0) {
            <!-- Custom actions -->
            @for (item of actionMenu(); track $index) {
              <ng-container
                [ngTemplateOutlet]="initialItemTemplate"
                [ngTemplateOutletContext]="{ item: item, isSubmenu: false }"
              />
            }
          } @else {
            <!-- Default Actions -->
            <ng-container [ngTemplateOutlet]="defaultActionMenuItemsTemplate" />
          }
        </ul>
      }
    }
    @if (!isAuthenticated()) {
      <div class="d-flex flex-fill"></div>
      <div class="me-2 mt-1">
        <ng-container [ngTemplateOutlet]="agentPortalLogoTemplate" />
      </div>
      <button class="btn btn-primary" (click)="goToLogin()">Log In</button>
    }
  </div>
</nav>

<ng-template #agentPortalLogoTemplate>
  <a class="navbar-brand" routerLink="/">
    <img
      [src]="agentPortalLogoIcon?.svg || agentPortalLogoIcon?.jpg || agentPortalLogoIcon?.png"
      alt="Agent Portal logo"
      [width]="240"
      [height]="64"
      priority
    />
  </a>
</ng-template>

<!-- Default action menu items -->
<ng-template #defaultActionMenuItemsTemplate>
  @if (isAuthenticated()) {
    <mh-user-profile />

    <div class="vr align-self-center d-lg-none"></div>
  }

  <button
    jest-id="navbar-toggler"
    class="d-lg-none navbar-toggler"
    type="button"
    aria-label="Toggle navigation"
    (click)="toggleCollabsedMenu()"
  >
    <svg-icon class="navbar-toggler-icon" [src]="navTogglerIcon?.svg" [applyClass]="true" />
  </button>
</ng-template>

<!-- collabsed menu template -->
<ng-template #collabsedMenu>
  <div class="collabsed-nav-header">
    <div class="navbar-brand">
      <picture>
        <source [srcset]="mainLogoIcon?.webp" type="image/webp" />
        <source [srcset]="mainLogoIcon?.jpg" type="image/jpeg" />
        <img [src]="mainLogoIcon?.jpg" alt="myhome logo" />
      </picture>
    </div>

    <button jest-id="close-btn" type="button" class="navbar-icon-btn" (click)="toggleCollabsedMenu()">
      <svg-icon class="nav-close-btn" [src]="closeBtnIcon?.svg" [applyClass]="true" />
    </button>
  </div>

  <ul class="navbar-nav flex-fill flex-column">
    @for (item of headerMenu(); track $index) {
      @if (showNavItem(item)) {
        <ng-container
          [ngTemplateOutlet]="navItemTemplate"
          [ngTemplateOutletContext]="{ item: item, isSubmenu: false }"
        />
      }
    }
  </ul>
</ng-template>

<!-- Nav Item template -->
<ng-template
  #initialItemTemplate
  let-item="item"
  let-isSubmenu="isSubmenu"
  let-callback="callback"
  let-cssClass="cssClass"
>
  <ng-container
    [ngTemplateOutlet]="navItemTemplate"
    [ngTemplateOutletContext]="{ item: item, isSubmenu: isSubmenu, callback: callback, cssClass: cssClass }"
  />
</ng-template>

<!-- Nav menu iems templates -->
<ng-template #navItemTemplate let-item="item" let-isSubmenu="isSubmenu" let-callback="callback" let-cssClass="cssClass">
  <li class="nav-item" [ngClass]="cssClass">
    @if (item.isRoot && !isSubmenu && !!item.submenu?.length) {
      <a
        jest-id="menu-item"
        class="btn btn-light"
        [class.root-menu-open]="item.isOpen"
        type="button"
        cdkOverlayOrigin
        #navTrigger="cdkOverlayOrigin"
        (click)="triggerSubMenu(item)"
      >
        <ng-container [ngTemplateOutlet]="navItemContentTemplate" [ngTemplateOutletContext]="{ item: item }" />
      </a>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="navTrigger"
        [cdkConnectedOverlayOpen]="item.isOpen ?? false"
        [cdkConnectedOverlayOffsetY]="10"
      >
        <ul class="nav-menu border bg-light">
          @for (subItem of item.submenu; track $index) {
            @if (showNavItem(subItem)) {
              <ng-container
                [ngTemplateOutlet]="initialItemTemplate"
                [ngTemplateOutletContext]="{
                  item: subItem,
                  isSubmenu: true,
                  callback: callback,
                }"
              />
            }
          }
        </ul>
      </ng-template>
    } @else {
      @if (!!item.submenu?.length) {
        <ul class="nav-menu border bg-light" [class.submenu]="isSubmenu">
          @for (subItem of item.submenu; track $index) {
            @if (showNavItem(subItem)) {
              <ng-container
                [ngTemplateOutlet]="initialItemTemplate"
                [ngTemplateOutletContext]="{
                  item: subItem,
                  isSubmenu: true,
                  callback: callback,
                }"
              />
            }
          }
        </ul>
      }

      <ng-container
        [ngTemplateOutlet]="navLinkTemplate"
        [ngTemplateOutletContext]="{ item: item, callback: callback || item.callback }"
      />
    }
  </li>
</ng-template>

<ng-template #navLinkTemplate let-item="item" let-callback="callback">
  @if (!!item.page) {
    <a
      class="btn"
      [class.nav-link]="!item.cssClass && !item.isRoot"
      [class.btn-light]="!item.cssClass && item.isRoot"
      [ngClass]="item.cssClass"
      [routerLink]="item.page"
      routerLinkActive="active"
      [attr.role]="!!item.submenu?.length || !!item.page ? 'button' : 'link'"
      (click)="callback ? (item.callbackParams ? callback(item.callbackParams) : callback()) : null"
    >
      <ng-container [ngTemplateOutlet]="navItemContentTemplate" [ngTemplateOutletContext]="{ item: item }" />
    </a>
  } @else if (!!item.externalLink) {
    <a
      class="btn"
      [class.nav-link]="!item.cssClass && !item.isRoot"
      [class.btn-light]="!item.cssClass && item.isRoot"
      [ngClass]="item.cssClass"
      target="_blank"
      [attr.role]="!!item.submenu?.length ? 'button' : 'link'"
      (click)="openExternalLink(item.externalLink)"
    >
      <ng-container [ngTemplateOutlet]="navItemContentTemplate" [ngTemplateOutletContext]="{ item: item }" />
    </a>
  } @else {
    <a
      class="btn"
      [class.nav-link]="!item.cssClass && !item.isRoot"
      [class.btn-light]="!item.cssClass && item.isRoot"
      [class.disabled]="item.disabled"
      [ngClass]="item.cssClass"
      [attr.role]="!!item.submenu?.length || callback ? 'button' : 'link'"
      [attr.aria-disabled]="item.disabled || null"
      (click)="!item.disabled && callback ? (item.callbackParams ? callback(item.callbackParams) : callback()) : null"
    >
      <ng-container [ngTemplateOutlet]="navItemContentTemplate" [ngTemplateOutletContext]="{ item: item }" />
    </a>
  }
</ng-template>

<ng-template #navItemContentTemplate let-item="item">
  <!-- menu item text -->
  <span class="text-truncate">{{ item.title }}</span>

  <!-- if menu item has submenu child then put arrow icon -->
  @if (!!item.submenu?.length) {
    <svg-icon class="nav-chevron" [applyClass]="true" [src]="chevronIcon?.svg" />
  }
</ng-template>
